/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrgAdminRegisterProfileModel } from '../../models/org-admin-register-profile-model';
import { OrgAdminRegisterProfileResultModel } from '../../models/org-admin-register-profile-result-model';

export interface OrgAdminRegisterProfilePost$Params {
  
    /**
     * Registration details including the target organization identifier.
     */
    body?: OrgAdminRegisterProfileModel
}

export function orgAdminRegisterProfilePost(http: HttpClient, rootUrl: string, params?: OrgAdminRegisterProfilePost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<OrgAdminRegisterProfileResultModel>> {
  const rb = new RequestBuilder(rootUrl, orgAdminRegisterProfilePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<OrgAdminRegisterProfileResultModel>;
    })
  );
}

orgAdminRegisterProfilePost.PATH = '/OrgAdmin/RegisterProfile';
